'use strict';

var React = require('react');

var SvgTroubleshootMajor = function SvgTroubleshootMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 5.893a4.893 4.893 0 0 1-6.681 4.557l-8.167 8.166a1.957 1.957 0 0 1-2.768-2.768l8.166-8.166a4.893 4.893 0 0 1 5.454-6.6c.363.068.463.508.199.766l-2.97 2.898 2.936 2.936 2.985-2.913c.26-.254.692-.152.76.205.056.298.086.605.086.92z"
  }));
};

exports.SvgTroubleshootMajor = SvgTroubleshootMajor;
